//
// Area pattern mapping
//

export const ENTITYPATTERN_AREA_MAP_DOCUMENT_NAME ='entity_pattern_area_map';

export const ENTITYPATTERN_AREA_MAP_RECORD_TYPE = "lookup";
export const ENTITYPATTERN_AREA_MAP_RECORD_SUBTYPE = "entity";

